import xhttp from 'src/utils/xhttp'

/**
 * 获取消息列表
 *
 * @param {Number} params.page
 * @param {Number} params.pageSize
 * @param {Boolean} params.isRead
 */
export function getMsgList(params) {
    return xhttp.get('/api/dev/notifications', { params })
}

/**
 * 设置消息为已读
 *
 * @param {Array} params.ids
 */
export function setMsgRead(params) {
    return xhttp.post('/api/dev/notification/read', params)
}

/**
 * 删除消息
 *
 * @param {Array} params.ids
 */
export function deleteMsg(params) {
    return xhttp.post('/api/dev/notification/delete', params)
}
